import 'babel-polyfill';
import 'react-app-polyfill/ie11';
import React from 'react';
import './index.css';
import './index.scss';

import FindUsApp from './FindUsApp';

const App = () => <FindUsApp />;

export default App;
